<template>
    <modal @close="$emit('close')" :max_width="600" :click_outside="!canInvite" class="relative" :width="isMobile?320:modalDesktopWidth">
      <img src="@/assets/SVG/cross-partners.svg" @click="close" class="absolute pin-r pin-t mt-20 mr-8 cursor-pointer z-20" alt="">
      <div v-if="canInvite">
         <p class="mt-16 text-center mb-8 px-8 font-bold text-lg ">Хотите присоединиться к команде <span class="text-brand-light" style="word-break: break-all">{{team_name}}</span>? </p>
         <div class="flex px-4 sm:px-10 md:items-center  text-lg flex-col md:flex-row p-6">
         <div class="w-full text-center cancel rounded-full py-4 font-bold px-20 sm:px-12 cursor-pointer hover-up mr-6" @click="$emit('close')">Отменить</div>
         <div class="text-center mt-5 md:mt-0 accept bg-brand-yellow py-4 px-16 rounded-full font-bold  cursor-pointer hover-up" @click="joinTeam">Присоединиться</div>
         </div>
      </div>
      <div v-else class="p-8 relative">
        <p class="font-bold text-center mt-8">
          У вас достигнут лимит команд.
        </p>
        <p class="mt-5 text-center mb-5">
          Выйдите из состава одной из команд в разделе “Мои команды”, чтобы добавить новую.
        </p>
      </div>
    </modal>
</template>

<script>
import Modal from '@/views/modals/base-modal';
import players from '@/clients/player.js';
import ModalMixn from '@/mixins/modals';

export default {
  name: 'ConfirmInviteModal',
  props: ['team_id', 'token', 'membershipCount'],
  mixins: [ModalMixn],
  components: { Modal },
  created() {
    if (!this.team_name) {
      this.getName();
    }
  },
  data() {
    return {
      team_name: '',
      maxTeamCount: 10,
    };
  },
  methods: {
    getName() {
      players.get(`teams/${this.team_id}/name`).then((res) => {
        this.team_name = res.data.name;
      });
    },
    joinTeam() {
      players.post(`teams/${this.team_id}/players?token=${this.token}`).then((res) => {
        this.$emit('joined', this.team_name);
      }).catch((e) => {
        this.$emit('error', e.response.data.errors, this.team_name);
      });
    },
  },
  computed: {
    canInvite() {
      return !this.membershipCount || this.membershipCount < this.maxTeamCount;
    },
    modalDesktopWidth() {
      return this.canInvite ? 600 : 400;
    },
  },
};

</script>

<style scoped>

.cancel {
    border: 1px solid black
}

</style>
